import React from "react";
import useMapsApiKey from "../hooks/useMapsApiKey";
import GmapLoaded, { IGmap } from "./GmapLoaded";
import useSuperAdmin from "./users/permissions/useSuperAdmin";

const placeholderStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "14px"
};

const placeholderClassName = "flex items-center justify-center border text-sm";

// The map key is fetched only for superadmins, and only once this component
// mounts (the station/city form is open) — never at app start, and never at
// all for non-superadmins. If the key can't be loaded, a message is shown in
// the map's place instead of a blank area.
const Gmap: React.FC<IGmap> = (props) => {
  const isSuperAdmin = useSuperAdmin();
  const { apiKey, loading } = useMapsApiKey(!!isSuperAdmin);

  if (!isSuperAdmin) return null;

  if (loading) {
    return (
      <div
        style={placeholderStyle}
        className={`${placeholderClassName} border-gray-200 bg-gray-50 text-gray-500`}
      >
        Duke ngarkuar hartën…
      </div>
    );
  }

  if (!apiKey) {
    return (
      <div
        style={placeholderStyle}
        className={`${placeholderClassName} border-red-200 bg-red-50 px-4 text-center text-red-600`}
      >
        Harta nuk mund të ngarkohej. Rifresko faqen ose provo përsëri.
      </div>
    );
  }

  return <GmapLoaded {...props} apiKey={apiKey} />;
};

export default Gmap;
